// import { useEffect, useState } from "react";
// import { Card, CardContent, CardMedia, Typography, Grid, Box } from "@mui/material";
// import { motion } from "framer-motion";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchPosts } from '../../store/blogSlice/blogSlice';
// import { RootState, AppDispatch } from '../../store/store';

// const LatestBlogs = () => {
//     const dispatch = useDispatch<AppDispatch>();
//     const { posts: blogs, loading, error } = useSelector((state: RootState) => state.blog);
//     const [page, setPage] = useState(1);

//     useEffect(() => {
//         window.scrollTo({ top: 0, behavior: "smooth" });
//     }, [page]);

//     useEffect(() => {
//         dispatch(fetchPosts(page));
//     }, [dispatch, page]);

//     return (
//         <Box sx={{ p: 4, textAlign: "center" }}>
//             <Typography variant="h4" fontWeight="bold" gutterBottom>
//                 Latest Blog Posts
//             </Typography>
//             <Grid container spacing={4} justifyContent="center">
//                 {blogs.slice(0, 4).map((blog, index) => (
//                     <Grid item xs={12} sm={6} md={3} key={blog._id}>
//                         <motion.div whileHover={{ scale: 1.05 }}>
//                             <Card sx={{ borderRadius: 4, boxShadow: 3 }}>
//                                 <CardMedia
//                                     component="img"
//                                     height="180"
//                                     image={blog.imageUrl || "/default-blog.jpg"} // Fallback image
//                                     alt={blog.title}
//                                 />
//                                 <CardContent>
//                                     <Typography variant="h6" fontWeight="bold" noWrap>
//                                         {blog.title}
//                                     </Typography>
//                                     <Typography variant="body2" color="text.secondary" noWrap>
//                                         {blog.content.substring(0, 100) + "..."}
//                                     </Typography>
//                                 </CardContent>
//                             </Card>
//                         </motion.div>
//                     </Grid>
//                 ))}
//             </Grid>
//         </Box>
//     );
// };

// export default LatestBlogs;

import { useEffect, useState } from "react";
import { Card, CardContent, CardMedia, Typography, Grid, Box } from "@mui/material";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../store/blogSlice/blogSlice";
import { RootState, AppDispatch } from "../../store/store";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const LatestBlogs = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { posts: blogs, loading, error } = useSelector((state: RootState) => state.blog);
    const [page, setPage] = useState(1);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [page]);

    useEffect(() => {
        dispatch(fetchPosts(page));
    }, [dispatch, page]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <Box sx={{ p: 4, textAlign: "center" }}>
            <Link to={`/en/bloglist`} style={{ textDecoration: 'none' }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Latest Blog Posts
                </Typography>
            </Link>
            <Slider {...settings}>
                {blogs.slice(0, 4).map((blog, index) => (
                    <Box key={blog._id} sx={{ px: 2 }}>
                        <motion.div whileHover={{ scale: 1.05 }}>
                            <Link to={`/en/bloglist/${blog._id}`} style={{ textDecoration: 'none' }}>
                                <Card sx={{ borderRadius: 4, boxShadow: 3, minHeight: '400px', maxHeight: '400px', margin: 0.5 }}>
                                    <CardMedia
                                        component="img"
                                        height="180"
                                        image={blog.imageUrl || "/default-blog.jpg"} // Fallback image
                                        alt={blog.title}
                                    />
                                    <CardContent>
                                        <Typography variant="h6" fontWeight="bold" >
                                            {blog.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Link>
                        </motion.div>
                    </Box>
                ))}
            </Slider>
        </Box>
    );
};

export default LatestBlogs;
